import { render, staticRenderFns } from "./BuscadorBibliotecaVirtualPage.vue?vue&type=template&id=449fb3e4"
import script from "./BuscadorBibliotecaVirtualPage.js?vue&type=script&lang=js&external"
export * from "./BuscadorBibliotecaVirtualPage.js?vue&type=script&lang=js&external"
import style0 from "./BuscadorBibliotecaVirtualPage.vue?vue&type=style&index=0&id=449fb3e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports